var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9975 15H56.9975V24H62.9975V15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.785 72L101 70.2025C99.0875 65.8275 94.77 63 90 63C85.23 63 80.9125 65.8275 79 70.2025L78.215 72H71.785L71 70.2025C69.0875 65.8275 64.77 63 60 63C55.23 63 50.9125 65.8275 49 70.2025L48.215 72H41.785L41 70.2025C39.0875 65.8275 34.77 63 30 63C25.23 63 20.9125 65.8275 19 70.2025L18.215 72H12V69C12 42.5325 33.5325 21 60 21C86.4675 21 108 42.5325 108 69V72H101.785ZM30 57C36.0975 57 41.7025 60.08 45 65.05C48.2975 60.08 53.9025 57 60 57C66.0975 57 71.7025 60.0775 75 65.05C78.2975 60.08 83.9025 57 90 57C94.1625 57 98.095 58.435 101.223 60.9275C97.4475 41.6175 80.4 27 60 27C39.6 27 22.5525 41.6175 18.7775 60.9275C21.9025 58.435 25.8375 57 30 57Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 108C42.055 108 36 101.945 36 94.5H42C42 98.635 45.365 102 49.5 102C53.635 102 57 98.635 57 94.5H63C63 101.945 56.945 108 49.5 108Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60H57V96H63V60Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlex);
export default __webpack_public_path__ + "static/media/Flex.ce46b5d4.svg";
export { ForwardRef as ReactComponent };